import {TweenLite, TimelineLite} from "gsap";
import {NineSliceButton} from "@nolimitcity/slot-game/bin/core/component/NineSliceButton";

export class CCTNineSliceButton extends NineSliceButton {

    protected getToOver():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            new TweenLite(this._buttonText, this._animationDuration, {alpha : 1}),
            new TweenLite(this._backplateMesh, this._animationDuration, {alpha : 0.6}),
            new TweenLite(this._graphicsContainer.scale, this._animationDuration, {x : 1, y : 1})
        ]);
        return tl;
    }

}